<template>
  <div class="games">
    <div class="filter">
      <button class="button"
              :class="{ 'active': state.currentFilter === 'All' }"
              @click="filter('All')">
        {{ i18n.all }}
      </button>
      <button class="button"
              :class="{ 'active': state.currentFilter === type }"
              @click="filter(type)"
              :key="type"
              v-for="type in state.filters">
        {{ filterLabel(type) }}
      </button>
    </div>
    <div class="content">
      <div class="item"
           :key="game.tenantGameId"
           v-for="game in state.games"
           @click="selectGame(game)">
        <div class="demo" @click="selectGame(game, $event, true)">Demo</div>
        <img class="thumb"
             v-if="game.thumbUrl"
             :src="game.thumbUrl"
             :alt="game.name" />
        <p v-else
           class="title">
          {{ game.displayName }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  assign,
  defaultTo,
  map,
  uniq,
} from 'lodash';
import { reactive, inject } from 'vue';

export default {
  name: 'Games',
  components: {},
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const i18n = inject('i18n');

    const state = reactive({
      games: props.data,
      filters: uniq(map(props.data, (game) => game.gameType)),
      currentFilter: 'All',
    });

    const filter = (type) => {
      state.currentFilter = type;
      state.games = props.data.filter((game) => (type === 'All' ? true : game.gameType === type));
    };

    const filterLabel = (type) => {
      const label = defaultTo(i18n[`type${type}`], type);
      return label;
    };

    const selectGame = (game, event, isDemo) => {
      if (event) {
        event.stopPropagation();
      }

      const gameTarget = JSON.parse(JSON.stringify(game));

      if (isDemo) {
        assign(gameTarget, {
          gameUrl: gameTarget.gameUrl.replace('isDemo=false', 'isDemo=true'),
          isDemo: true,
        });
      } else {
        assign(gameTarget, {
          gameUrl: gameTarget.gameUrl.replace('isDemo=true', 'isDemo=false'),
          isDemo: false,
        });
      }

      window.parent.postMessage({
        action: 'OpenGame',
        value: gameTarget,
      }, '*');
    };

    return {
      state,
      filter,
      filterLabel,
      selectGame,
      i18n,
    };
  },
};
</script>

<style lang="scss" scoped>
.games {
  overflow-x: hidden;

  .filter {
    display: block;
  }

  .content {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    align-items: center;
    column-gap: 10px;
    row-gap: 20px;
    padding: 0 10px;
    padding-bottom: 40px;
    padding-right: 30px;
    margin: 0;
    overflow-x: hidden;
  }

  .item {
    position: relative;
    display: grid;
    align-content: center;
    border-radius: 10px;
    height: 100px;
    background: rgba(255, 255, 255, 0.2);
    cursor: pointer;
    box-shadow: 1px 30px 40px -28px #8b2f61;
    -webkit-box-shadow: 1px 30px 40px -28px #8b2f61;
    -moz-box-shadow: 1px 30px 40px -28px #8b2f61;
  }

  .demo {
    position: absolute;
    top: 5px;
    left: 5px;
    display: block;
    text-decoration: none;
    background: black;
    color: whitesmoke;
    font-size: 12px;
    text-transform: uppercase;
    padding: 4px 6px;
    border-radius: 4px;
  }

  .thumb {
    width: 100%;
    height: inherit;
    max-height: 100%;
    object-fit: cover;
    border-radius: inherit;
    font-size: 0;
    user-select: none;
    pointer-events: none;
  }

  .title {
    text-align: center;
    font-size: 12px;
    font-weight: 700;
  }
}

.filter {
  margin: 0 10px 20px 10px;

  .button {
    min-width: 60px;
    padding: 0 10px;
    color: #fff;
    border-radius: 6px;
    font-size: 16px;
    line-height: 32px;
    outline: none;
    border: none;
    cursor: pointer;
    font-weight: 700;
    margin-right: 4px;
    background: transparent;
    transition: all 0.14s ease;

    &:hover:not(.active) {
      background: rgba(255, 255, 255, 0.1);
    }
  }

  .active {
    background: rgba(255, 255, 255, 0.2);
  }
}
</style>
